// Copyright (c) 2016 Deere & Company

import OtherCreditsPanelContainer from './other-credits-panel-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    errors: state.claims.pip.claim.errors,
    isEditable: state.claims.pip.isEditable,
    otherCreditDescriptions: state.claims.otherCreditDescriptions,
    otherCredits: state.claims.pip.claim.otherCredits
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(OtherCreditsPanelContainer);



// WEBPACK FOOTER //
// ./src/claim/pip/components/other-credits-panel/index.js